import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import * as Yup from "yup";
import { Field, FormikProvider, useFormik } from "formik";
import { Spin } from "antd";
import { Col, Form, Row, Modal, Button } from "react-bootstrap";
import CustomSelect from "../../../CustomControls/CustomSelect";
import { get, post } from "../../../helpers/api_helper";
import CustomFlatpickr from "../../../CustomControls/CustomFlatpickr";
import CustomInput from "../../../CustomControls/CustomInput";
import { errorMessage, successMessage } from "../CommonFunctions";
import { SVGICON } from "../../../constant/theme";
import moment from "moment";
import {
  GET_GetLogoTypeDropDownList,
  POST_GetLogoValidityDetailByID,
  POST_LogoValidityInsert,
  POST_LogoValidityUpdate,
} from "../../../helpers/url_helper";

const AddLogoValidity = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const { PrimaryIdParam } = useParams();

  const [logoTypeOptions, setLogoTypeOptions] = useState([]);

  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));

  const validationSchema = Yup.object().shape({
    LogoType: Yup.string().trim().required("Logo Type is required field"),
    ValidFrom: Yup.string().trim().required("Valid From is required field"),
    ValidTo: Yup.string().trim().required("Valid To is required field"),
  });

  const formik = useFormik({
    validationSchema: validationSchema,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmit(values, formikHelpers),
    initialValues: {
      LogoValidityIDEncrypted: PrimaryIdParam
        ? window.atob(PrimaryIdParam)
        : "",
      LogoType: "",
      ValidFrom: new Date(),
      ValidTo: new Date(),
    },
    validateOnBlur: false,
  });

  const {
    values: { ValidFrom, ValidTo },
  } = formik;

  useEffect(() => {
    if (!ValidFrom) {
      formik.setFieldValue("ValidFrom", "");
    }
    if (!ValidTo) {
      formik.setFieldValue("ValidTo", "");
    }

    if (ValidTo && ValidTo < ValidFrom) {
      formik.setFieldValue("ValidTo", ValidFrom);
    }
  }, [ValidFrom, ValidTo]);

  const handleValidSubmit = (values) => {
    setIsLoading(true);
    let payload = {
      ...values,
      ValidFrom: values?.ValidFrom
        ? moment(values?.ValidFrom).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
      ValidTo: values?.ValidTo
        ? moment(values?.ValidTo).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      CreatedByEncrypted: AuthUser?.ReferenceIDEncrypt,
    };
    post(
      PrimaryIdParam ? POST_LogoValidityUpdate : POST_LogoValidityInsert,
      payload
    )
      .then((response) => {
        setIsLoading(true);
        if (response?.IsSuccess) {
          successMessage(response?.Message);
          setTimeout(() => {
            navigate(-1);
          }, 1000);
        } else {
          errorMessage(response?.Message);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getLogoTypeDDL = async () => {
    setIsLoading(true);
    await get(GET_GetLogoTypeDropDownList, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setLogoTypeOptions(
            response?.List?.map((item) => ({
              label: item?.LogoTypeName,
              value: item?.LogoType,
            }))
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    getLogoTypeDDL();
    if (PrimaryIdParam) {
      getLogoValidityDetailByID(window.atob(PrimaryIdParam));
    }
  }, []);

  const getLogoValidityDetailByID = async (logoValidityID) => {
    setIsLoading(true);
    await post(POST_GetLogoValidityDetailByID, {
      LogoValidityIDEncrypted: logoValidityID,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formik.setValues({
            ...response,
            ValidFrom: response?.ValidFrom ? new Date(response?.ValidFrom) : "",
            ValidTo: response?.ValidTo ? new Date(response?.ValidTo) : "",
          });
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  return (
    <div className="card m-1">
      <div className="card-body p-1">
        <Spin
          size="large"
          spinning={isLoading}
          tip={"Loading..."}
          style={{ position: "fixed" }}
        >
          <div className="tbl-caption p-2">
            <h4 className="heading mb-0">
              {PrimaryIdParam ? "Edit" : "Add"} Logo Validity
            </h4>
          </div>
          <hr className="mt-0 mb-1"></hr>
          <div className="p-2 pt-0">
            <FormikProvider value={formik}>
              <Form onSubmit={formik.handleSubmit}>
                <Row>
                  <Col lg={3}>
                    <Field
                      label="Logo Type"
                      name="LogoType"
                      placeholder={"Select Logo Type"}
                      component={CustomSelect}
                      options={logoTypeOptions}
                      required
                      autoFocus
                    />
                  </Col>
                  <Col lg={3}>
                    <Field
                      label="Valid From"
                      name="ValidFrom"
                      placeholder={"Select Valid From"}
                      component={CustomFlatpickr}
                      required
                      options={{
                        altInput: true,
                        altFormat: "j-M-Y",
                        dateFormat: "d-m-Y",
                      }}
                    />
                  </Col>
                  <Col lg={3}>
                    <Field
                      label="Valid To"
                      name="ValidTo"
                      placeholder={"Select Valid To"}
                      component={CustomFlatpickr}
                      required
                      options={{
                        altInput: true,
                        altFormat: "j-M-Y",
                        dateFormat: "d-m-Y",
                        minDate: ValidFrom ? new Date(ValidFrom) : "",
                      }}
                    />
                  </Col>
                </Row>
                <hr className="mt-1 mb-2"></hr>
                <button type="submit" className="btn btn-primary btn-sm me-2">
                  <i className="fa-solid fa-floppy-disk"></i> Submit
                </button>
                <button
                  type="button"
                  className="btn btn-danger btn-sm"
                  onClick={(e) => {
                    navigate(-1);
                  }}
                >
                  <i className="fa fa-cancel"></i> Cancel
                </button>
              </Form>
            </FormikProvider>
          </div>
        </Spin>
      </div>
    </div>
  );
};

export default AddLogoValidity;
